// extracted by mini-css-extract-plugin
export default {"one":"SecOne_one__aCyTZ","main":"SecOne_main__GQBip","gif":"SecOne_gif__CreT8"};